<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>RIWAYAT PENDIDIKAN FORMAL</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>

      <div
        slot="masih"
        slot-scope="props">
        {{ props.row.masih ? 'Ya' : 'Tidak' }}
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Riwayat Pendidikan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.bidang_studi.$error}">
            <label> Bidang Studi </label>
            <j-input
              v-model="$v.data_master.bidang_studi.$model"
              placeholder="Bidang Studi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenjang.$error}">
            <label> Jenjang Pendidikan </label>
            <j-single-select
              v-model="$v.data_master.jenjang.$model"
              :options="list_jenjang"
              placeholder="Pilih Jenjang Pendidikan"
              label="name"/>
              <!-- <j-input
              v-model="$v.data_master.jenjang.$model"
              placeholder="Jenjang Pendidikan"/> -->
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.gelar.$error}">
            <label> Gelar Akademik </label>
            <j-input
              v-model="$v.data_master.gelar.$model"
              placeholder="Gelar Akademik"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.satuan.$error}">
            <label> Satuan Pendidikan Formal </label>
            <j-input
              v-model="$v.data_master.satuan.$model"
              placeholder="Satuan Pendidikan Formal"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.fakultas.$error}">
            <label> Fakultas </label>
            <j-input
              v-model="$v.data_master.fakultas.$model"
              placeholder="Fakultas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.kependidikan.$error}">
            <label> Kependidikan </label>
            <b-form-radio-group
              v-model="$v.data_master.kependidikan.$model"
              :options="list_kependidikan"
              :stacked="true"
              :disabled="false"
              class="jFormGroup"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun_masuk.$error}">
            <label> Tahun Masuk </label>
            <j-input
              v-model="$v.data_master.tahun_masuk.$model"
              type="number"
              placeholder="Tahun Masuk"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun_lulus.$error}">
            <label> Tahun Lulus </label>
            <j-input
              v-model="$v.data_master.tahun_lulus.$model"
              type="number"
              placeholder="Tahun Lulus"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nim.$error}">
            <label> NIS / NISN / NIM </label>
            <j-input
              v-model="$v.data_master.nim.$model"
              type="number"
              placeholder="NIS / NISN / NIM"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masih.$error}">
            <label> Masih Studi / Kuliah </label>
            <b-form-radio-group
              v-model="$v.data_master.masih.$model"
              :options="list_yes_no"
              :stacked="true"
              :disabled="false"
              class="jFormGroup"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-input
              v-model="$v.data_master.semester.$model"
              type="number"
              placeholder="Semester"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.ipk.$error}">
            <label> Rata-rata Ujian Akhir / IPK </label>
            <j-input
              v-model="$v.data_master.ipk.$model"
              type="number"
              placeholder="Semester"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Riwayat Kependidikan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.bidang_studi.$error}">
            <label> Bidang Studi </label>
            <j-input
              v-model="$v.data_master.bidang_studi.$model"
              :disabled="readOnly"
              placeholder="Bidang Studi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenjang.$error}">
            <label> Jenjang Pendidikan </label>
            <j-single-select
              v-model="$v.data_master.jenjang.$model"
              :options="list_jenjang"
              :disabled="readOnly"
              placeholder="Pilih Jenjang Pendidikan"
              label="name"/>
              <!-- <j-input
              v-model="$v.data_master.jenjang.$model"
              :disabled="readOnly"
              placeholder="Jenjang Pendidikan"/> -->
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.gelar.$error}">
            <label> Gelar Akademik </label>
            <j-input
              v-model="$v.data_master.gelar.$model"
              :disabled="readOnly"
              placeholder="Gelar Akademik"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.satuan.$error}">
            <label> Satuan Pendidikan Formal </label>
            <j-input
              v-model="$v.data_master.satuan.$model"
              :disabled="readOnly"
              placeholder="Satuan Pendidikan Formal"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.fakultas.$error}">
            <label> Fakultas </label>
            <j-input
              v-model="$v.data_master.fakultas.$model"
              :disabled="readOnly"
              placeholder="Fakultas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.kependidikan.$error}">
            <label> Kependidikan </label>
            <b-form-radio-group
              v-model="$v.data_master.kependidikan.$model"
              :options="list_kependidikan"
              :stacked="true"
              :disabled="readOnly"
              class="jFormGroup"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun_masuk.$error}">
            <label> Tahun Masuk </label>
            <j-input
              v-model="$v.data_master.tahun_masuk.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Masuk"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun_lulus.$error}">
            <label> Tahun Lulus </label>
            <j-input
              v-model="$v.data_master.tahun_lulus.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Lulus"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nim.$error}">
            <label> NIS / NISN / NIM </label>
            <j-input
              v-model="$v.data_master.nim.$model"
              :disabled="readOnly"
              type="number"
              placeholder="NIS / NISN / NIM"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masih.$error}">
            <label> Masih Studi / Kuliah </label>
            <b-form-radio-group
              v-model="$v.data_master.masih.$model"
              :options="list_yes_no"
              :stacked="true"
              :disabled="readOnly"
              class="jFormGroup"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-input
              v-model="$v.data_master.semester.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Semester"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.ipk.$error}">
            <label> Rata-rata Ujian Akhir / IPK </label>
            <j-input
              v-model="$v.data_master.ipk.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Semester"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jPendidikan',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['bidang_studi', 'jenjang', 'gelar', 'satuan', 'tahun_masuk', 'tahun_lulus', 'nim', 'masih', 'semester', 'ipk'],
      options: {
        headings: {
          bidang_studi: 'BIDANG STUDI',
          jenjang: 'JENJANG PENDIDIKAN',
          gelar: 'GELAR AKADEMIK',
          satuan: 'SATUAN PENDIDIKAN FORMAL',
          tahun_masuk: 'TAHUN MASUK',
          tahun_lulus: 'TAHUN LULUS',
          nim: 'NIM',
          masih: 'MASIH KULIAH',
          semester: 'SEMESTER',
          ipk: 'IPK',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['bidang_studi', 'jenjang', 'gelar', 'satuan', 'tahun_masuk', 'tahun_lulus', 'nim', 'masih', 'semester', 'ipk'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListPendidikan(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        bidang_studi: '',
        jenjang: null,
        gelar: '',
        satuan: '',
        fakultas: '',
        kependidikan: false,
        tahun_masuk: null,
        tahun_lulus: null,
        nim: null,
        semester: null,
        ipk: null,
        masih: false,
      },
      list_kependidikan: [
        {
          value: true,
          text: 'LPTK',
        },
        {
          value: false,
          text: 'Tidak',
        },
      ],
      list_yes_no: [
        {
          value: true,
          text: 'Ya',
        },
        {
          value: false,
          text: 'Tidak',
        },
      ],
      list_jenjang: [
        {
          id: 'SD',
          name: 'SD',
        },
        {
          id: 'SLTP',
          name: 'SLTP',
        },
        {
          id: 'SLTA',
          name: 'SLTA',
        },
        {
          id: 'D3',
          name: 'D3',
        },
        {
          id: 'S1',
          name: 'S1',
        },
        {
          id: 'S2',
          name: 'S2',
        },
        {
          id: 'S3',
          name: 'S3',
        },
      ],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createPendidikan', 'updatePendidikan', 'deletePendidikan']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        bidang_studi: '',
        jenjang: null,
        gelar: '',
        satuan: '',
        fakultas: '',
        kependidikan: false,
        tahun_masuk: null,
        tahun_lulus: null,
        nim: null,
        semester: null,
        ipk: null,
        masih: false,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        bidang_studi: '',
        jenjang: null,
        gelar: '',
        satuan: '',
        fakultas: '',
        kependidikan: false,
        tahun_masuk: null,
        tahun_lulus: null,
        nim: null,
        semester: null,
        ipk: null,
        masih: false,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        bidang_studi: param.row.bidang_studi,
        jenjang: param.row.jenjang,
        gelar: param.row.gelar,
        satuan: param.row.satuan,
        fakultas: param.row.fakultas,
        kependidikan: param.row.kependidikan,
        tahun_masuk: param.row.tahun_masuk,
        tahun_lulus: param.row.tahun_lulus,
        nim: param.row.nim,
        semester: param.row.semester,
        ipk: param.row.ipk,
        masih: param.row.masih,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createPendidikan(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updatePendidikan(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deletePendidikan(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        bidang_studi: { required },
        jenjang: { required },
        gelar: { required },
        satuan: { required },
        fakultas: { required },
        kependidikan: { required },
        tahun_masuk: { required },
        tahun_lulus: { required },
        nim: { required },
        semester: { required },
        ipk: { required },
        masih: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jPendidikan.vue